import { useContext } from "react";
import { AppContext } from "core/context";

function useUpdateMenu(area: string) {
    const appContext = useContext(AppContext);
    appContext.updateArea(area);
}

export default useUpdateMenu;
